<template>
  <div id="app" class="A-wrap">
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "app",
  mounted() {
    let $window = $(window);
    let height = $window.height();
    let width = $window.width();
    this.$store.dispatch("setWindowStyle", { width, height });
  }
};
</script>

<style lang="less">
@import "./public/static/css/public.less";
/*设置保时捷字体*/
@font-face {
  font-family: "porsche-font";
  src: url("../static/fonts/PorscheNextWCy-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "thin-porsche-font";
  src: url("../static/fonts/PorscheNextWCy-Thin.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "porsche-next-tt-bold";
  src: url("../static/fonts/PorscheNextWCy-Bold.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}

.quill-editor {
  /*工具栏内用*/
  .ql-font {
    span[data-value="porsche-font"]::before {
      content: "porsche-font" !important;
      font-family: "porsche-font";
    }
    span[data-value="thin-porsche-font"]::before {
      content: "thin-porsche-font" !important;
      font-family: "thin-porsche-font";
    }
    span[data-value="porsche-next-tt-bold"]::before {
      content: "porsche-next-tt-bold" !important;
      font-family: "porsche-next-tt-bold";
    }
    span[data-value="黑体"]::before {
      content: "黑体" !important;
      font-family: "黑体";
    }
  }
  /*编辑器内容用*/
  .ql-font-porsche-font {
    font-family: "porsche-font";
  }
  .ql-font-thin-porsche-font {
    font-family: "thin-porsche-font";
  }
  .ql-font-porsche-next-tt-bold {
    font-family: "porsche-next-tt-bold";
  }
  .ql-font-黑体 {
    font-family: "黑体";
  }
  .ql-snow .ql-picker.ql-font {
    width: 145px;
  }
}
/*编辑器内容用*/
.ql-font-porsche-font {
  font-family: "porsche-font";
}
.ql-font-thin-porsche-font {
  font-family: "thin-porsche-font";
}
.ql-font-porsche-next-tt-bold {
  font-family: "porsche-next-tt-bold";
}
.ql-font-黑体 {
  font-family: "黑体";
}

.clear {
  clear: both;
}

body,
button,
input,
select,
td,
textarea,
th {
}
address,
caption,
cite,
code,
dfn,
em,
th,
td,
var* {
  font-style: normal;
  font-weight: bold;
}
body,
th,
td,
button,
input,
select,
textarea {
}

.thin-font {
  font-family: thin-porsche-font, porsche-font, porsche-next-tt-bold;
  font-size: 14px;
}

.bold-font {
  font-family: "porsche-font", Arial, "黑体", "SimHei", "华文黑体", "STHeiti",
    sans-serif;
  font-weight: bold;
}
* {
  margin: 0;
  padding: 0;
}

body {
  width: 100%;
  height: 100%;
  min-width: 1345px;
  font-family: "thin-porsche-font", Arial, "黑体", "SimHei", "华文黑体",
    "STHeiti", "宋体", "SimSun", sans-serif;
}
a {
  text-decoration: none;
}
/*flex*/
.flex {
  display: -webkit-box; /* 老版本语法: Safari,  iOS, Android browser, older WebKit browsers.  */
  display: -moz-box; /* 老版本语法: Firefox (buggy) */
  display: -ms-flexbox; /* 混合版本语法: IE 10 */
  display: -webkit-flex; /* 新版本语法： Chrome 21+ */
  display: flex; /* 新版本语法： Opera 12.1, Firefox 22+ */
}
.flex-start {
  -webkit-box-align: flex-start;
  -moz-box-align: flex-start;
  /*混合版本语法*/
  -ms-flex-align: flex-start;
  /*新版本语法*/
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
/*垂直居中*/
.flex-ver {
  -webkit-box-align: center;
  -moz-box-align: center;
  /*混合版本语法*/
  -ms-flex-align: center;
  /*新版本语法*/
  -webkit-align-items: center;
  align-items: center;
}
/*水平居中*/
.flex-hor {
  -webkit-box-pack: center;
  -moz-box-pack: center;
  /*混合版本语法*/
  -ms-flex-pack: center;
  /*新版本语法*/
  -webkit-justify-content: center;
  justify-content: center;
}
.space-around {
  -webkit-box-pack: space-around;
  -moz-box-pack: space-around;
  /*混合版本语法*/
  -ms-flex-pack: space-around;
  /*新版本语法*/
  -webkit-justify-content: space-around;
  justify-content: space-around;
}
.space-between {
  -webkit-box-pack: space-between;
  -moz-box-pack: space-between;
  /*混合版本语法*/
  -ms-flex-pack: space-between;
  /*新版本语法*/
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
/* 父元素-横向换行 */
.flex-hw {
  /* 09版 */
  /*-webkit-box-lines: multiple;*/
  /* 12版 */
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}
.rank .jiantou img {
  height: 34px;
  position: absolute;
  top: 56%;
  margin-top: -17px;
}
.rank .rank-text {
  padding-left: 40px !important;
  font-size: 32px !important;
}
.rank {
  position: relative;
}
.el-notification .el-icon-circle-cross {
  color: rgba(213, 0, 28, 1) !important;
}
.el-message-box__close:hover,
.el-icon-close:hover {
  color: rgb(153, 153, 153) !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?9bcc2ab8